import React from 'react';
import { View } from 'react-native';

import { Button, Label, Text } from '../../../components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

/**
 * The single large "you are here" card of the guided My day flow. Renders the
 * focused step front-and-center with its content and primary/secondary actions.
 */
const StepFocusCard = ({
	kicker,
	title,
	description,
	badgeCount,
	statusLabel,
	children,
	primaryAction,
	secondaryAction,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.card}>
			{
				Boolean(kicker) && (
					<Text style={styles.kicker}>{kicker}</Text>
				)
			}
			<View style={styles.titleRow}>
				<Text style={styles.title}>{title}</Text>
				{
					Boolean(badgeCount) && (
						<Label label={String(badgeCount)} primary={true} style={styles.badge} />
					)
				}
				{
					Boolean(statusLabel) && (
						<Label label={statusLabel.label} {...statusLabel.props} style={styles.badge} />
					)
				}
			</View>
			{
				Boolean(description) && (
					<Text style={styles.description}>{description}</Text>
				)
			}
			{children}
			{
				// Button's `secondary` prop renders the solid filled style; the default
				// is the subtle outline. The progression action must be the solid one.
				Boolean(primaryAction) && (
					<Button
						label={primaryAction.label}
						onPress={primaryAction.onPress}
						loading={primaryAction.loading}
						disabled={primaryAction.disabled || primaryAction.loading}
						secondary={true}
						style={styles.primaryButton}
					/>
				)
			}
			{
				Boolean(secondaryAction) && (
					<Button
						label={secondaryAction.label}
						onPress={secondaryAction.onPress}
						loading={secondaryAction.loading}
						disabled={secondaryAction.disabled || secondaryAction.loading}
						style={styles.secondaryButton}
					/>
				)
			}
		</View>
	);
};

const createStyles = (theme) => ({
	card: {
		backgroundColor: theme.mainBg1,
		borderRadius: 12,
		padding: 14,
		marginBottom: 10,
		borderWidth: 1,
		borderColor: theme.border3,
		// Accent marks this as the "you are here" card among the plain sections.
		borderLeftWidth: 3,
		borderLeftColor: theme.primary1,
	},
	kicker: {
		fontSize: 11,
		fontWeight: '700',
		color: theme.text2,
		textTransform: 'uppercase',
		letterSpacing: 0.8,
		marginBottom: 2,
	},
	titleRow: {
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	title: {
		fontSize: 20,
		fontWeight: '700',
		color: theme.text1,
		marginRight: 6,
	},
	badge: {
		marginBottom: 0,
	},
	description: {
		marginTop: 4,
		fontSize: 14,
		color: theme.text2,
	},
	primaryButton: {
		marginTop: 12,
	},
	secondaryButton: {
		marginTop: 8,
	},
});

export default StepFocusCard;
